import { useEffect, type RefObject } from 'react';

const MARGIN = 8;

function releasePopover(popover: HTMLElement) {
  const { style } = popover;
  style.maxHeight = '';
  style.top = '';
}

function constrainPopover(popover: HTMLElement) {
  const { style } = popover;
  releasePopover(popover);

  const maxHeight = window.innerHeight - MARGIN * 2;
  style.maxHeight = `${maxHeight}px`;

  const itemTop = popover.getBoundingClientRect().top;
  const height = popover.offsetHeight;
  const lowestTop = window.innerHeight - height - MARGIN;
  const constrainedTop = Math.max(MARGIN, Math.min(itemTop, lowestTop));

  style.top = `${constrainedTop - itemTop}px`;
}

export default function useConstrainedCollapsedSubmenu(
  containerRef: RefObject<HTMLElement | null>,
  enabled: boolean,
) {
  useEffect(() => {
    const container = containerRef.current;
    if (!enabled || !container) return undefined;

    const constrainAll = () => {
      container
        .querySelectorAll<HTMLElement>('ul ul')
        .forEach(constrainPopover);
    };

    constrainAll();

    const observer = new MutationObserver(constrainAll);
    observer.observe(container, { childList: true, subtree: true });
    window.addEventListener('resize', constrainAll);

    return () => {
      observer.disconnect();
      window.removeEventListener('resize', constrainAll);
      // Clear the inline styles we applied so expanding the nav restores the
      // default (uncapped) submenu styling instead of leaving popovers capped.
      container.querySelectorAll<HTMLElement>('ul ul').forEach(releasePopover);
    };
  }, [containerRef, enabled]);
}
